import React from 'react';
import PropTypes from 'prop-types';
import Box from 'components/atoms/Box/Box';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import Typography from 'components/atoms/Typography/Typography';
import Link from 'components/atoms/Link/Link';
import { Trans } from 'react-i18next';

import { useFooterMenuStyles } from './footerMenuStyles';
import { MainLogoGray } from 'assets/imageList';
import { useMediaQuery, useTheme } from '@material-ui/core';

export default function FooterMenu(props) {
  const classes = useFooterMenuStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Box className={classes.box}>
      <GridContainer spacing={1} alignItems="center">
        <GridItem xs={12} sm={3} md={2}>
          <Box>
            <MainLogoGray height="30px" />
          </Box>
        </GridItem>
        <GridItem xs={12} sm={6} md={5}>
          <Typography className={classes.primaryText}>
            <Link href="https://www.lifenome.com/">
              <Trans i18nKey="dna24.footer.companyName" />
            </Link>
          </Typography>
          <Typography className={classes.primaryText}>
            <Trans i18nKey="dna24.footer.companyAddressStreet" />
            {', '}
            {isMobile && <br />}
            <Trans i18nKey="dna24.footer.companyAddressCity" />
          </Typography>
          <Typography className={classes.primaryText}>
            <Link href="mailto:info@lifenome.com">
              <Trans i18nKey="dna24.footer.companyEmail" />
            </Link>
            {', '}
            {isMobile && <br />}
            <Trans i18nKey="dna24.footer.companyTelephone" />
          </Typography>
        </GridItem>
        <GridItem xs={12} sm={3} md={5}>
          <Typography className={classes.secondaryText}>
            <Link href="https://www.lifenome.com/blog-newsletter/">
              <Trans i18nKey="dna24.menu.press" />
            </Link>
          </Typography>
          <Typography className={classes.secondaryText}>
            <Link href="https://www.lifenome.com/about/#contact">
              <Trans i18nKey="dna24.menu.contact" />
            </Link>
          </Typography>
        </GridItem>
      </GridContainer>
    </Box>
  );
}

FooterMenu.propTypes = {
  children: PropTypes.node,
};
